










































































































































































































































































































































import { defineComponent } from '@vue/composition-api';
import { mapState, mapGetters, mapActions } from 'vuex';
import Panel from '@/features/ui/panel/Panel.global.vue';
import Form from '@/features/ui/form/Form.global.vue';
import WizardButton from '@/components/clickables/WizardButton.global.vue';
import Cell from '@/features/ui/layout/Cell.global.vue';
import Flex from '@/features/ui/layout/Flex.global.vue';
import PropertyList from '../step2/PropertyList.vue';
import InputField from '@/features/ui/inputs/InputField.global.vue';
import InputText from '@/features/ui/inputs/InputText.global.vue';
import InputCheckbox from '@/features/ui/inputs/InputCheckbox.global.vue';
import InputSelect from '@/features/ui/inputs/InputSelect.global.vue';
import { Option } from '@/features/ui/inputs/model';
import { kebabCase } from 'lodash';
import {
  aufzugUseCaseOptions,
  EnterpriseProjectObjectUseCase,
  EnterpriseProjectServiceType,
  heizungUseCaseOptions,
} from '@/features/app-enterprise-project/enterprise-project-constants';
import CreateBuildingsButton from '@/features/app-enterprise-project/views/enterprise-project-create/components/CreateBuildingsButton.vue';
import {
  EnterpriseProjectObjectProduct,
  InfrastructureVariantType,
  IWCloudType,
  LiegenschaftProduct,
  LiegenschaftUseCase,
  ProjectBuilding,
} from '@/features/core/store/page-modules/enterprise-project-create/create-module-types';
import { defaultUseCaseOptions, defaultProducts } from '@/features/app-enterprise-project/enterprise-project-constants';
import structuredClone from '@ungap/structured-clone';
import { isMainServiceRequired } from '@/features/app-enterprise-project/views/enterprise-project-create/components/step3/step-3-helpers';

export default defineComponent<any, Record<string, unknown>, any, any, any>({
  components: {
    Panel,
    Form,
    WizardButton,
    Cell,
    Flex,
    PropertyList,
    InputField,
    InputText,
    InputCheckbox,
    InputSelect,
    CreateBuildingsButton,
  },
  data() {
    return {
      selectedBuildings: [],
      openSelectLiegenschaften: false,
      searchProperty: null,
      saving: false,
      showUnselectedBuildings: true,
    };
  },
  computed: {
    ...mapGetters([
      'activeBuilding',
      'liegenschaftenWithEmptyConfigurations',
      'buildingsWithElevators',
      'mainBuildingsWithComments',
      'allMainBuildingProductInformationIsValid',
      'projectType',
    ]),
    ...mapState({
      buildings: (state: any) => state.EnterpriseProjectCreateModule.newProjectData.buildings,
      projectReference: (state: any) => state.EnterpriseProjectCreateModule.newProjectData.projectReference,
      buildingsCreated: (state: any) => state.EnterpriseProjectCreateModule.buildingsCreated,
      editableBuildings: (state: any) => state.EnterpriseProjectCreateModule.editableBuildings,
    }),
    liegenshaftBuildings() {
      return this.buildings.filter((building: any) => building.liegenshaft);
    },
    unselectedBuildings() {
      if (this.searchProperty) {
        return this.liegenshaftBuildings.filter(
          (building: ProjectBuilding) =>
            building.id !== this.activeBuilding.id &&
            !(
              this.buildingsCreated &&
              this.editableBuildings &&
              !this.editableBuildings.has(`${building.buildingId}`)
            ) &&
            building.name.toLowerCase().includes(this.searchProperty.toLowerCase()),
        );
      }
      return this.liegenshaftBuildings.filter((building: any) => building.id !== this.activeBuilding.id);
    },
    infrastructureVariantOptions() {
      return Object.values(InfrastructureVariantType);
    },
    iwCloudOptions() {
      return Object.values(IWCloudType);
    },
    disabledBuilding(): boolean {
      return !!(
        this.buildingsCreated &&
        this.editableBuildings &&
        !this.editableBuildings.has(`${this.activeBuilding.buildingId}`)
      );
    },
    mainServiceRequired(): boolean {
      // Main Service not mandatory in a “Preisänderung”, “Produkterweiterung” and “Produktänderung”
      return isMainServiceRequired(this.projectType);
    },
    sortedUnselectedBuildings() {
      return [...this.unselectedBuildings].sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' }),
      );
    },
  },

  watch: {
    activeBuilding: {
      handler() {
        this.onActiveBuildingUpdated();
      },
      deep: true,
    },
  },
  mounted() {
    this.onActiveBuildingUpdated();
  },
  methods: {
    ...mapActions({
      addToastMessages: 'ADD_TOAST_MESSAGES',
    }),
    slug(value: string): string {
      return kebabCase(value);
    },
    onInputSelectChange(value: string | null, useCase: LiegenschaftUseCase) {
      if (!value) {
        useCase.monthlyPriceInEuros = null;
        useCase.oneTimePriceInEuros = null;
      }
    },
    onCheckboxChange(useCase: LiegenschaftUseCase) {
      if (!useCase.checked) {
        useCase.monthlyPriceInEuros = null;
        useCase.oneTimePriceInEuros = null;
      }
    },
    onInfrastructureVariantChange(value: string | null) {
      if (value) {
        this.clearProductPricing(EnterpriseProjectObjectProduct.IW_CLOUD);
      }
    },
    handleSelectLiegenshaften() {
      this.openSelectLiegenschaften = !this.openSelectLiegenschaften;
    },
    async handleSaveConfigurations() {
      this.saving = true;
      const buildingIds = this.liegenshaftBuildings
        .filter((building: any) => building.checked)
        .map((building: any) => building.buildingId);
      this.$store.commit('applyActiveConfigurations', {
        buildingIds,
        mainService: this.activeBuilding.mainService,
        products: this.activeBuilding.products,
        useCases: this.activeBuilding.useCases,
        details: {
          invoiceName: this.activeBuilding.invoiceName,
          preInspection: this.activeBuilding.preInspection,
          serviceLevel: this.activeBuilding.serviceLevel,
        },
        includesComments: this.activeBuilding.includesComments,
      });

      // go to the next Liegenschaften with no configurations, otherwise go to the first one on the list.
      if (this.liegenschaftenWithEmptyConfigurations.length > 0) {
        const firstBuildingWithEmptyConfigurations: ProjectBuilding = this.liegenschaftenWithEmptyConfigurations[0];
        this.$store.commit('setActiveStep2BuildingId', firstBuildingWithEmptyConfigurations.buildingId);
      } else {
        this.$store.commit('setActiveStep2BuildingId', this.liegenshaftBuildings[0].buildingId);
      }

      // uncheck/reset selected Liegenschaften
      this.liegenshaftBuildings.forEach((building: any) => {
        if (building.checked) {
          building.checked = false;
        }
      });

      await this.$store.dispatch('saveToDB', { apolloClient: this.$apollo, finalSave: false });
      // Show toast message to inform user that the configurations have been applied to the selected Liegenschaften
      await this.addToastMessages({
        duration: 1000,
        messages: [{ text: 'Konfigurationen wurden auf die ausgewählten Liegenschaften angewendet', class: 'success' }],
      });
      this.saving = false;
    },
    nextProperty() {
      this.$store.dispatch('getNextActiveBuildingForStep2', this.$apollo);
    },
    passOnHideEvent() {
      // Hide modal
      this.$emit('hide');
    },
    inputSelectReduce(option: Option) {
      return option.value;
    },
    getProductTypeHeading(type: EnterpriseProjectObjectProduct) {
      switch (type) {
        case EnterpriseProjectObjectProduct.INFRASTRUCTURE_VARIANT:
          return 'Infrastrukturvariante';
        case EnterpriseProjectObjectProduct.IW_CLOUD:
          return 'IW-Cloud';
        default:
          return null;
      }
    },
    onActiveBuildingUpdated() {
      if (!this.activeBuilding.useCases || this.activeBuilding.useCases.length == 0) {
        this.activeBuilding.useCases = structuredClone(defaultUseCaseOptions);
      }

      if (!this.activeBuilding.products || this.activeBuilding.products.length == 0) {
        this.activeBuilding.products = structuredClone(defaultProducts);
      }

      // Clear any prices where the option is not set
      for (let i = 0; i < this.activeBuilding.products.length; i++) {
        if (!this.activeBuilding.products[i].option) {
          this.activeBuilding.products[i].monthlyPriceInEuros = null;
          this.activeBuilding.products[i].oneTimePriceInEuros = null;
        }
      }
    },

    mainServiceOptions() {
      // NB: GK_HUB_G should be excluded on FE
      return [
        {
          label: 'GK_HUB_L_Kabel',
          value: EnterpriseProjectServiceType.GK_HUB_L_CABLE,
        },
        {
          label: 'GK_HUB_L_GDSP_MOBILFUNK',
          value: EnterpriseProjectServiceType.GK_HUB_L_GDSP_MOBILFUNK,
        },
      ];
    },
    heizungUseCaseOptions() {
      return heizungUseCaseOptions;
    },
    aufzugUseCaseOptions() {
      return aufzugUseCaseOptions;
    },
    isProductSelected(productType: string): boolean {
      const matchingProduct = this.activeBuilding.products.find(
        (product: LiegenschaftProduct) => product.productType == productType,
      );
      return !!matchingProduct?.option;
    },
    clearProductPricing(productType: string) {
      const product: LiegenschaftProduct | undefined = this.activeBuilding.products.find(
        (product: LiegenschaftProduct) => product.productType == productType,
      );

      if (product) {
        product.monthlyPriceInEuros = null;
        product.oneTimePriceInEuros = null;
      }
    },
    isTGAGroup(useCaseType: EnterpriseProjectObjectUseCase) {
      return [
        EnterpriseProjectObjectUseCase.TGA_DIGITIZATION,
        EnterpriseProjectObjectUseCase.TGA_MONITORING,
        EnterpriseProjectObjectUseCase.TGA_INTEGRATION,
      ].includes(useCaseType);
    },
    isOtherGroup(useCaseType: EnterpriseProjectObjectUseCase) {
      return [
        EnterpriseProjectObjectUseCase.REMOTE_METER_READING,
        EnterpriseProjectObjectUseCase.SERVICE_MANAGEMENT,
        EnterpriseProjectObjectUseCase.SMG,
        EnterpriseProjectObjectUseCase.CONSUMPTION_DATA_ACQUISITION,
        EnterpriseProjectObjectUseCase.CONSUMPTION_INFORMATION_DURING_THE_YEAR,
        EnterpriseProjectObjectUseCase.SMOKE_ALARM_MONITORING,
      ].includes(useCaseType);
    },
    selectAllFilteredBuildings() {
      this.showUnselectedBuildings = false;
      this.unselectedBuildings.forEach((building: any) => {
        building.checked = true;
      });
      this.showUnselectedBuildings = true;
    },
    deselectAllFilteredBuildings() {
      this.showUnselectedBuildings = false;
      this.unselectedBuildings.forEach((building: any) => {
        building.checked = false;
      });
      this.showUnselectedBuildings = true;
    },
    goToNextStep() {
      if (this.buildingsWithElevators.length > 0) {
        this.$store.dispatch('setUpdateTab', 'elevatorSelection');
        this.$store.dispatch('saveToDB', { apolloClient: this.$apollo, finalSave: false });
      } else if (this.mainBuildingsWithComments.length > 0) {
        this.$store.dispatch('setUpdateTab', 'comments');
        this.$store.dispatch('saveToDB', { apolloClient: this.$apollo, finalSave: false });
      }
    },
  },
});
